import { SVGProps } from 'react';

const ChevronScaleExtraSmallKindUpDown = (props: SVGProps<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9 4L6 1L3 4M3 8L6 11L9 8"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ChevronScaleExtraSmallKindUpDown;
